import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {httpGetAccess} from '../http/accesses.http'
import {Access} from '@/features/accesses/types'

export const useGetAccess = ({
    urlParams,
    options
}: {
    urlParams: {
        accessId: string
    }
    options?: Omit<UseQueryOptions<Access>, 'queryKey' | 'queryFn'>
}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ACCESS, urlParams.accessId],
        queryFn: () => httpGetAccess({urlParams}),
        ...options
    })
}
